import React, { useState, useEffect } from 'react';
import {
  Input,
  Button,
  Flex,
  Form,
  Tag,
  Select
} from "antd";
import {
  MinusOutlined,
  QuestionCircleOutlined,
  PlusOutlined,
  UndoOutlined,
} from "@ant-design/icons";

const BulkAttributeList = ({ tabActive, selectedField, setSavedattributes, setIsAction, applyToAll }) => {
  const [data, setData] = useState([]);
  const [max_size, setMax_size] = useState(0);
  const [undoErrorIndex, setUndoErrorIndex] = useState(null);
  const [savedData, setSavedData] = useState([]);
  const [attribute_element_type, setAttributeElementType] = useState(null);
  const [dropdownValues, setDrropdownValues] = useState([]);

  const nonRemovedCount = data.filter(item => !item.removed).length;

  useEffect(() => {
    if (savedData && savedData.length > 0) {
      setSavedattributes(pre => ({
        ...pre,
        [tabActive.key]: savedData
      }));
    }
  }, [savedData, tabActive.key]);


  useEffect(() => {

    if (tabActive?.custom_field_set && selectedField) {
      //   const selectedVal = tabActive.custom_field_set.filter(
      //   item =>
      //     item.name === selectedField.label &&
      //     item.attribute_element_type === selectedField.type
      // );

      const selectedVal = tabActive.custom_field_set.find(item => item.name === selectedField.label);

      setAttributeElementType(selectedVal);

      if (selectedVal && selectedVal.attribute_element_type != "dropdown") {

        const values = selectedVal.values || [];
        const size = selectedVal.max_size || 0;
        // Tag initial values
        // setData(values.map(item => ({ ...item, removed: false, source: 'initial' })));



        let valueData = values.map(item => {

          let values_mapped = null, selected_values = []
          let isexist = savedData.filter(item1 => item1.id === item.id && item1.prod_id === item1.prod_id)
          //  if (selectedVal[0].attribute_element_type == "dropdown") {

          //  }
          if (isexist && isexist.length > 0) {
            return {
              ...item,
              new_val: isexist[0].value,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id,
              attribute_element_type: selectedVal.attribute_element_type, // always set
            }
          }
          else {
            return {
              ...item,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id,
              attribute_element_type: selectedVal.attribute_element_type, // always set
            }
          }
        })
        setData(valueData)

        setMax_size(size);

      } else {
        const values = selectedVal.values || [];
        const size = selectedVal.max_size || 0;
        // Tag initial values
        // setData(values.map(item => ({ ...item, removed: false, source: 'initial' })));
        let valdata = selectedVal.values_data.map(item => ({
          value: item.values,
          label: item.values
        }))
        setDrropdownValues(valdata);
        let valueData = values.map(item => {

          let values_mapped = null, selected_values = []
          let isexist = savedData.filter(item1 => item1.id === item.id && item1.prod_id === item1.prod_id)

          if (isexist && isexist.length > 0) {
            return {
              ...item,
              new_val: isexist[0].value,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id,
              attribute_element_type: selectedVal.attribute_element_type, // always set
            }
          }
          else {
            let splitedValues = item.val ? item.val.split(',') : [];
          
            return {
              ...item,
              removed: false,
              source: 'initial',
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id,
              selected_values:splitedValues,
              attribute_element_type: selectedVal.attribute_element_type, // always set
            }
          }
        })

        setData(valueData)

        setMax_size(size);
      }
    }
  }, [tabActive, selectedField]);

  const handleValuesChange = (newValues, index) => {
    
    setData(prevData => {
      const updated = [...prevData];
      updated[index] = {
        ...updated[index],
        selected_values: newValues.map(val => ({ label: val, value: val }))
      };
      return updated;
    });

    // Update savedData also
    setSavedData(prevSaved => {
      const currentItem = data[index];
      const tempKey = currentItem.tempKey || `${currentItem.attribute_key}_${index + 1}`;
      const newEntry = {
        ...currentItem,
        selected_values: newValues.map(val => ({ label: val, value: val })),
        value: newValues.join(','),
        tempKey,
      };

      const existingIndex = prevSaved.findIndex(item => item.tempKey === tempKey);
      if (existingIndex !== -1) {
        const updatedSaved = [...prevSaved];
        updatedSaved[existingIndex] = newEntry;
        return updatedSaved;
      }

      return [...prevSaved, newEntry];
    });
  };


  const handleAddValue = () => {
    let value_data = JSON.parse(selectedField.value);

    if (nonRemovedCount < max_size) {
      setData(prev => {
        // Find the lowest available PRIMARY_n (including removed)
        const allNumbers = prev
          .map(item => {
            const match = item.name && item.name.match(/^PRIMARY_(\d+)$/);
            return match ? parseInt(match[1], 10) : null;
          })
          .filter(n => n !== null);
        let nextIndex = 1;
        while (allNumbers.includes(nextIndex)) {
          // If PRIMARY_n exists and is removed, allow reuse only if it's a new value (no id)
          const existsRemoved = prev.find(item => item.name === `PRIMARY_${nextIndex}` && item.removed && !item.id);
          if (existsRemoved) break;
          nextIndex++;
        }
        // Try to reuse a removed new value with the same PRIMARY_n
        const indexToRestore = prev.findIndex(item => item.removed === true && item.name === `PRIMARY_${nextIndex}` && !item.id);
        if (indexToRestore !== -1) {
          const updated = [...prev];
          updated[indexToRestore].removed = false;
          return updated;
        } else {
          // Add new one with PRIMARY_n
          return [
            ...prev,
            {
              val: '',
              removed: false,
              source: 'new',
              attribute_key: value_data.attribute_key,
              name: `PRIMARY_${nextIndex}`,
              prod_id: tabActive.prod_id,
              store: tabActive.store,
              store_id: tabActive.store_id,
              tempKey: `${value_data.attribute_key}_${Date.now()}_${Math.random()}` // unique tempKey
            }
          ];
        }
      });
    }
  };


  const handleRemoveValue = (value, index) => {
    // Log the value being removed

    setSavedData(prevSaved => {
      const existing = prevSaved.find(item => item.id === value.id);
      if (existing) {
        return prevSaved.map(item =>
          item.id === value.id ? { ...item, removed: true } : item
        );
      } else {
        return [...prevSaved, { ...value, removed: true }];
      }
    });

    setData(prev => {
      // Mark the item as removed
      const updated = prev.map((item, i) =>
        i === index ? { ...item, removed: true } : item
      );
      // Renumber non-removed new values to fill PRIMARY_n gaps
      const usedNumbers = updated
        .filter(item => !item.removed && item.name && item.name.startsWith('PRIMARY_'))
        .map(item => parseInt(item.name.replace('PRIMARY_', ''), 10));
      let nextNum = 1;
      // Collect tempKey for renumbered new values
      const renumbered = [];
      for (let i = 0; i < updated.length; i++) {
        const item = updated[i];
        if (!item.removed && item.source === 'new') {
          // Find the next available PRIMARY_n
          while (usedNumbers.includes(nextNum)) nextNum++;
          updated[i] = { ...item, name: `PRIMARY_${nextNum}` };
          renumbered.push({ tempKey: item.tempKey, name: `PRIMARY_${nextNum}` });
          usedNumbers.push(nextNum);
          nextNum++;
        }
      }
      // Also update savedData to match renumbered names
      setSavedData(prevSaved => prevSaved.map(saved => {
        if (saved.source === 'new' && saved.tempKey) {
          const found = renumbered.find(r => r.tempKey === saved.tempKey);
          if (found) return { ...saved, name: found.name };
        }
        return saved;
      }));
      return updated;
    });
    if (typeof setIsAction === 'function') {
      setIsAction(true);
    }
  };

  const handleUndoValue = (index) => {
    const nonRemovedCount = data.filter(item => !item.removed).length;
    if (nonRemovedCount >= max_size) {
      setUndoErrorIndex(index);
      return;
    }

    setData(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, removed: false } : item
      )
    );
    // Update savedData by id or tempKey
    setSavedData(prevSaved => {
      const current = data[index];
      if (current.id) {
        return prevSaved.map(item =>
          item.id === current.id ? { ...item, removed: false } : item
        );
      } else if (current.tempKey) {
        return prevSaved.map(item =>
          item.tempKey === current.tempKey ? { ...item, removed: false } : item
        );
      } else {
        return prevSaved;
      }
    });
    setUndoErrorIndex(null);
  };

  return (
    <div className='List'>
      {data.map((value, valIndex) => {
        // Skip rendering if new value is removed
        if (value.removed && value.source === 'new') return null;

        return (
          <div className='ListRow' key={valIndex}>
            <div className='ListCol'>
              <span className='ValueLabel' style={value.removed ? { textDecoration: 'line-through' } : {}}>
                Current Value {valIndex + 1}
              </span>
              <p style={value.removed ? { textDecoration: 'line-through', color: 'gray' } : {}}>
                {value.val}



              </p>
            </div>
            <div className='ListCol'>
              {value.attribute_element_type != 'dropdown' && (
                <Form.Item
                  className="abc"
                  key={valIndex}
                  label={
                    <span style={value.removed ? { textDecoration: 'line-through', color: 'gray' } : {}}>
                      New Value {valIndex + 1}&nbsp;
                      {/* <QuestionCircleOutlined
                      style={{
                        color: "rgba(0, 0, 0, 0.45)",
                        cursor: "pointer",
                      }}
                      title="This is the Attribute Value."
                    /> */}
                    </span>
                  }
                  style={{ marginBottom: 0 }}
                >
                  <Flex
                    style={{
                      display: "flex",
                      paddingBottom: "20px",
                      width: "100%",
                      gap: "8px"
                    }}
                    align="start"
                  >
                    <div style={{ width: "100%", display: 'flex', alignItems: 'center', gap: 8 }}>
                      {!value.removed ? (
                        <Input.TextArea
                          placeholder='Enter New Value'
                          value={value.new_val || ''} // Controlled 
                          onChange={(e) => {
                            const newValue = e.target.value;
                            // Step 1: Update local `data` state
                            setData(prevData =>
                              prevData.map((item, i) =>
                                i === valIndex ? { ...item, new_val: newValue, counter: valIndex + 1 } : item
                              )
                            );

                            // Step 2: Update `savedData` correctly for both existing and new values
                            setSavedData(prevSaved => {
                              // Generate a tempKey for tracking new entries
                              let valueparse = JSON.parse(selectedField.value)
                              const tempKey = value.tempKey || (value.id ? null : `${valueparse.attribute_key}_${valIndex + 1}`);

                              // First check by id (for existing)
                              const existingById = value.id
                                ? prevSaved.find(item => item.id === value.id)
                                : null;

                              if (existingById) {
                                return prevSaved.map(item =>
                                  item.id === value.id
                                    ? { ...item, value: newValue, counter: valIndex + 1 }
                                    : item
                                );
                              }

                              // Then check by tempKey (for new)
                              const existingByTemp = tempKey ? prevSaved.find(item => item.tempKey === tempKey) : null;
                              const newEntry = {
                                ...value,
                                value: newValue,
                                counter: valIndex + 1,
                                tempKey, // tempKey हमेशा रहे
                              };

                              if (existingByTemp) {
                                return prevSaved.map(item =>
                                  item.tempKey === tempKey ? newEntry : item
                                );
                              }

                              // If not found at all, add it
                              return [...prevSaved, newEntry];
                            });
                          }}

                          maxLength={250}
                          style={{ width: "100%" }}
                          showCount={{
                            formatter: ({ count, maxLength }) =>
                              `${count}/${maxLength}`,
                          }}
                        />

                      ) : (
                        <>
                          <Button
                            icon={<UndoOutlined />}
                            onClick={() => handleUndoValue(valIndex)}
                          >
                            Undo
                          </Button>
                          <Tag color="red">Removed</Tag>
                          {undoErrorIndex === valIndex && (
                            <p style={{ color: 'red', margin: 0 }}>
                              Please remove any value field while doing undo value field.
                            </p>
                          )}
                        </>
                      )}
                    </div>

                    {!value.removed && (
                      <Button
                        type="text"
                        danger
                        icon={<MinusOutlined />}
                        style={{ width: 32, padding: 0 }}
                        className='RemoveAttr'
                        onClick={() => handleRemoveValue(value, valIndex)}
                      />
                    )}
                  </Flex>
                </Form.Item>
              )}
              {value.attribute_element_type == 'dropdown' && (
                <Form.Item
                  className="abc"
                  key={valIndex}
                  label={
                    <span style={value.removed ? { textDecoration: 'line-through', color: 'gray' } : {}}>
                      New Value {valIndex + 1}&nbsp;
                      {/* <QuestionCircleOutlined
                      style={{
                        color: "rgba(0, 0, 0, 0.45)",
                        cursor: "pointer",
                      }}
                      title="This is the Attribute Value."
                    /> */}
                    </span>
                  }
                  style={{ marginBottom: 0 }}
                >

                  <Select
                    mode="multiple"
                    optionFilterProp="label"
                    allowClear
                    showSearch
                    style={{ width: "100%" }}
                    placeholder="Select Values"
                    defaultValue={value.selected_values || []}
                    onChange={e => handleValuesChange(e, valIndex)}
                    options={dropdownValues}
                  />
                </Form.Item>
              )}

            </div>
          </div>
        );
      })}
      {attribute_element_type != "dropdown" && <div className="btnBox">
        <Button
          icon={<PlusOutlined />}
          onClick={handleAddValue}
          disabled={nonRemovedCount >= max_size}
        >
          Add a value
        </Button>
      </div>}
    </div>
  );
};

export default BulkAttributeList;
